import * as React from 'react';
import Helmet from 'react-helmet';
import Radium, { StyleRoot } from 'radium';
import { Col, Grid, Row } from 'react-bootstrap';
import { Route, Switch } from 'react-router';

import ContactPage from './Feature/contactpage';
import CookieNotification from './Feature/components/cookie_notification';
import DownloadPage from './Feature/downloads';
import Footer from './Feature/components/footer';
import HomePage from './Feature/homepage';
import Login from './Feature/login';
import Menu from './Feature/components/menu';
import NotFound from './Feature/not_found';
import OrderLayout from './Feature/order';
import CookiesPolicyPage from './Feature/CookiesPolicy';
import TeamPage from './Feature/teampage';
import TermsAndConditions from './Feature/terms_and_conditions';
import WorkshopCategoriesPage from './Feature/workshopcategoriespage';
import WorkshopCategoryPage from './Feature/workshopcategorypage';
import PrivacyPolicy from './Feature/PrivacyPolicy';
import Schools from './Feature/Schools';

@Radium({ userAgent: 'all' })
export default class App extends React.Component {
  render() {
    return (
      <StyleRoot>
        <Helmet>
          <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossOrigin="anonymous" />
          <link href="https://fonts.googleapis.com/css?family=Indie+Flower|Raleway:400,700&amp;subset=latin-ext" rel="stylesheet" />
          <script src="https://use.fontawesome.com/0a45492051.js" />
        </Helmet>
        <Menu />
        <Grid fluid style={styles.mainContainer}>
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route path="/spolky" component={TeamPage} />
            <Route path="/kontakt" component={ContactPage} />
            <Route exact path="/workshopy" component={WorkshopCategoriesPage} />
            <Route path="/workshopy/:id" component={WorkshopCategoryPage} />
            <Route path="/prihlaseni" component={Login} />
            <Route path="/objednavka" component={OrderLayout} />
            <Route path="/ke-stazeni" component={DownloadPage} />
            <Route path="/navstivili-jsme" component={Schools} />
            <Route path="/zasady-cookies" component={CookiesPolicyPage} />
            <Route path="/zasady-osobnich-udaju" component={PrivacyPolicy} />
            <Route path="/obchodni-podminky" component={TermsAndConditions} />
            <Route component={NotFound} />
          </Switch>
        </Grid>
        <Grid fluid style={{ margin: 0 }}>
          <Row style={styles.footerRow}>
            <Col md={12}>
              <Footer />
            </Col>
          </Row>
        </Grid>
        <CookieNotification />
      </StyleRoot>
    );
  }
}

const styles = {
  mainContainer: {
    marginTop: 66,
    paddingLeft: 0,
    paddingRight: 0,
    flex: '1 0 auto',
    width: '100%'
  },
  footerRow: {
    backgroundColor: '#333',
    paddingTop: '40px',
    paddingBottom: '40px'
  }
};



// WEBPACK FOOTER //
// ./src/browser/App.jsx